import { render, staticRenderFns } from "./PointDetail.vue?vue&type=template&id=d6d5948e&scoped=true&"
import script from "./PointDetail.vue?vue&type=script&lang=ts&"
export * from "./PointDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PointDetail.vue?vue&type=style&index=0&id=d6d5948e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d5948e",
  null
  
)

export default component.exports